/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.partner.demo.rpc.PartnerDemoDdgRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const generateDemoContentRpc = {
  serviceName: 'com.hubspot.partner.demo.rpc.PartnerDemoDdgRpc',
  rpcName: 'generateDemoContent',
  auth: 'app',
  fingerprint: 'jL81Z2nPEP7-AzObESpJPpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: true
};